import angular from 'angular';
import _ from "lodash";

angular.module('folkeuni').component('customerOrderDetailLine', {
  bindings: {
    guid:'=',
    orderId:'=',
    product: '<'
  },
  controller:function(){
    var $ctrl = this;

    $ctrl.ticketTypes = [];
    $ctrl.standardAmount = 0;

    function getTicketTypes() {
      if(!$ctrl.product) {
        return [];
      }

      var types = $ctrl.product.quantity > $ctrl.product.discount.length ? [{type: 'Standard', name: 'Standard'}] : [];

      var discountTypes = _.chain($ctrl.product.discount)
      .map(function(discount) {
        var ticketTypeObj = {
          type:discount.type
        }
        ticketTypeObj.name = "";
        if(discount.type == 2){
          ticketTypeObj.name = "Student";
        }else if(discount.type == 3){
          ticketTypeObj.name =  discount.keyAccount.name;
        }

        return ticketTypeObj;
      })
      .uniqBy('type')
      .value();

      types = types.concat(discountTypes);
      return types;
    };

    $ctrl.$onInit = function() {

        $ctrl.ticketTypes = getTicketTypes();
        $ctrl.standardAmount = $ctrl.product.quantity - $ctrl.product.discount.length;

    };
  },
  templateUrl:'/shop-dist/templates/customer-order-detail-line.html'
});
